<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <path d="M3.75 0H4.75V2H3.75zM3.75 9.5H4.75V12H3.75z" transform="translate(5.25 3)" />
        <path
          fill-rule="nonzero"
          d="M3.946 10.096c.704 0 1.31-.102 1.818-.306.508-.204.898-.496 1.17-.876.272-.38.408-.826.408-1.338 0-.36-.07-.67-.21-.93-.14-.26-.346-.484-.618-.672-.272-.188-.602-.35-.99-.486s-.83-.256-1.326-.36c-.432-.104-.786-.208-1.062-.312-.276-.104-.48-.232-.612-.384s-.198-.344-.198-.576c0-.4.16-.712.48-.936.32-.224.756-.336 1.308-.336.456 0 .892.074 1.308.222.416.148.816.378 1.2.69l.528-1.128c-.232-.216-.508-.398-.828-.546-.32-.148-.67-.262-1.05-.342-.38-.08-.77-.12-1.17-.12-.664 0-1.242.11-1.734.33-.492.22-.874.526-1.146.918C.95 3 .814 3.448.814 3.952c0 .368.066.686.198.954.132.268.326.498.582.69.256.192.576.358.96.498s.828.258 1.332.354c.424.096.78.196 1.068.3.288.104.504.23.648.378.144.148.216.334.216.558 0 .376-.162.668-.486.876-.324.208-.782.312-1.374.312-.536 0-1.028-.072-1.476-.216-.448-.144-.888-.376-1.32-.696L.646 9.088c.264.216.57.4.918.552.348.152.722.266 1.122.342.4.076.82.114 1.26.114z"
          transform="translate(5.25 3)"
        />
      </g>
      <circle cx="9" cy="9" r="8.5" :stroke="color" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
